/*
 * Structural-only sx contributions for the materialUI Button wrapper.
 *
 * Colors, typography, shape, and shadows are now driven by each theme's
 * MuiButton.styleOverrides (see app/styles/themes/*.js) so a brand refresh
 * does not require re-editing this file.
 *
 * What remains here: layout-only helpers that behave consistently across
 * themes (fullWidth, block, link, justIcon sizing).
 */

const buttonStyle = {
  // Intentionally empty — theme drives base button visuals.
  button: {},

  fullWidth: { width: '100%' },
  block: { width: '100% !important' },
  link: {
    '&,&:hover,&:focus': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },

  // Icon-only button: square aspect ratio, no text padding.
  justIcon: {
    paddingLeft: 12,
    paddingRight: 12,
    minWidth: 41,
    width: 41,
    height: 41,
    '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
      marginRight: 0,
    },
  },

  // Size variants — padding only; fontSize comes from theme.
  lg: { padding: '1.125rem 2.25rem' },
  sm: { padding: '0.40625rem 1.25rem' },

  // Role stubs kept so existing `color={...}` props don't crash when
  // buttonStyle[color] is looked up. The theme decides what each color
  // renders as.
  primary: {},
  info: {},
  success: {},
  warning: {},
  danger: {},
  rose: {},
  white: {},
  error: {},
  secondary: {},
  jyrneyYellow: {},
  jyrneyBlue: {},
  jyrneyRed: {},
  twitter: {},
  facebook: {},
  google: {},
  linkedin: {},
  pinterest: {},
  youtube: {},
  tumblr: {},
  github: {},
  behance: {},
  dribbble: {},
  reddit: {},
  transparent: {},
  default: {},

  // Retained for back-compat: simple/round/disabled also have theme-level
  // handling via ownerState, so leave these as no-ops here.
  simple: {},
  round: {},
  disabled: {},
  variant: {},

  // Medium size (default) — no-op so Button.js size-lookup doesn't crash.
  medium: {},
}

export default buttonStyle
